import { Typography, colorsPalette } from '@lingoda/ui';

export const FAQBlock = () => (
    <Typography variant="body2" htmlColor={colorsPalette.blackAlpha[70]}>
        Please see our FAQ for details about plans and promotions.
    </Typography>
);
